"use client";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Fqa = ({ title }: { title: string }) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("instructions");

  return (
    <>
      <div className="bg-white rounded-2xl card-shadow overflow-hidden hover:shadow-sm transition-shadow duration-300">
        <div className="p-6">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            {t("use_guide")}
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-gray-700">
            <li>{t("use_guide.step1").replace("band-", title)}</li>
            <li>{t("use_guide.step2")}</li>
            <li>{t("use_guide.step3")}</li>
            <li>{t("use_guide.step4")}</li>
            <li>{t("use_guide.step5")}</li>
          </ol>
        </div>
      </div>
      <div className="bg-white rounded-2xl card-shadow overflow-hidden mt-5 hover:shadow-sm transition-shadow duration-300">
        <div className="p-6">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">
            {t("fqa.title")}
          </h3>
          <div className="space-y-4">
            <div>
              <h4 className="font-medium text-gray-800">Q: {t("fqa.q1")}</h4>
              <p className="text-gray-600 mt-1">A: {t("fqa.a1")}</p>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Q: {t("fqa.q2")}</h4>
              <p className="text-gray-600 mt-1">A: {t("fqa.a2")}</p>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Q: {t("fqa.q3")}</h4>
              <p className="text-gray-600 mt-1">A: {t("fqa.a3")}</p>
            </div>
            <div>
              <h4 className="font-medium text-gray-800">Q: {t("fqa.q4")}</h4>
              <p className="text-gray-600 mt-1">A: {t("fqa.a4")}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Fqa;
